<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left>
        <a class="link color-theme-white popup-close" href="#">
          <i class="icon icon-back"></i>
          <span>返回</span>
        </a>
      </f7-nav-left>
      <f7-nav-title>{{ title }}</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="clearChecked">&nbsp;清除</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content">
      <f7-searchbar
        search-container=".search-list"
        search-in=".item-title"
        disable-button-text="取消"
        :placeholder="`${title}关键字`"
        v-if="search"
        style="background-color: #ffffff;"
      ></f7-searchbar>
      <div
        class="has-content searchbar-not-found"
        style="text-align: center;"
        v-if="data.length === 0">
        暂无数据
      </div>
      <f7-list class="search-list searchbar-found" v-else>
        <f7-list-item
          radio
          v-for="item in data"
          :title="item.name"
          :value="item.code"
          :key="item.code"
          :checked="checkedVal === item.code"
          @change="checkedItem">
        </f7-list-item>
      </f7-list>
    </div>
  </f7-page>
</template>
<script>
export default {
  name: 'PopupRadio',
  props: ['title', 'data', 'result', 'search'],
  data() {
    return {
      checkedVal: this.result,
    };
  },
  methods: {
    clearChecked() {
      this.checkedVal = '';
      this.$emit('update:result', this.checkedVal);
    },
    checkedItem(event) {
      this.checkedVal = event.target.value;
      this.$emit('update:result', this.checkedVal);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PopupRadio.vue